import React from "react";

/* 
  Button to create a new Data Request
  < Output = adds a row to the RequestTable >
*/

export default function NewRequest({ handleNewRequest }) {
  return <button className="orange-button" style={{width: 126}} onClick={handleNewRequest}>New Request</button>;
}
